import React from "react";

/**
 * Error boundary for Info Pages feature.
 */
export class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		if (process.env.NODE_ENV !== "production") {
			console.error("ErrorBoundary caught an error:", error, info);
		}
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="infopage__error">
					<h2>Something went wrong while loading Information Pages.</h2>
					<p>Please refresh the page or try again later.</p>
				</div>
			);
		}
		return this.props.children;
	}
}
